<div id="chat-mirror-main">
  <div class="mirror-header">
    <h3>{{ 'agent:panel.chat.mirror.title' | translate }}</h3>
    <button
      [ngClass]="extendedMirror ? 'cng-ico_fullscreen_exit' : 'cng-ico_fullscreen'"
      (click)="onExtend()"
      title="{{ 'agent:panel.chat.button.extend' | translate }}"
      [hidden]="!chatHasOngoingSharingSession"
    ></button>
    <button
      [ngClass]="adjustedView ? 'cng-ico_split_off' : 'cng-ico_split'"
      (click)="changeView()"
      [hidden]="!chatHasOngoingSharingSession"
    ></button>
  </div>
  <div [ngClass]="!adjustedView ? 'mirror-body' : 'mirror-body real-size-body'">
    <div id="screen-sharing-container" class="screen-sharing-container" [ngClass]="{ hidden: !chatHasOngoingSharingSession }"></div>
    <div id="no-screen-sharing-container" *ngIf="!chatHasOngoingSharingSession">
      <div class="one_mirroring_action" *ngIf="hasScreenSharing">
        <div class="cng-ico_tips"></div>
        <span>{{ 'agent:panel.chat.actions.screen-sharing.one_mirroring_action' | translate }}</span>
      </div>
      <div class="one_mirroring_action" *ngIf="visitorHasNoCapabilityForScreenSharing">
        <div class="cng-ico_tips"></div>
        <span>{{ 'agent:panel.chat.actions.screen-sharing.navigator_not_compatible' | translate }}</span>
      </div>
      <button
        matRipple
        *ngIf="enableMirroring"
        (click)="askForScreenSharing()"
        class="send_request-btn cng-ico_cobrowsing"
        [disabled]="screenSharingDemandPending || hasScreenSharing || visitorHasNoCapabilityForScreenSharing || getConferenceButton()"
      >
        <span class="label">{{ 'agent:panel.chat.actions.screen-sharing.demand' | translate }}</span>
      </button>
      <ng-container *ngIf="!enableMirroring">
        <p class="no-permission-screen-sharing">{{ 'agent:panel.chat.actions.screen-sharing.no_permission' | translate }}</p>
      </ng-container>
    </div>
  </div>
</div>
